export const SERVICE_COST_LIMITS = {
  MIN: 1
};

export const CUSTOM_POPUP_TYPES = {
  SUCCESS: 0,
  ERROR: 1,
  WARNING: 2
};

export const FINANCE_FLOW_STORAGE_KEYS = {
  FINANCE_DATA: 'financeFlowV3Data',
  FLOW_STATE: 'financeFlowV3State'
};

export const DENEFITS_CONTRACT_TYPE = 8;

// Maps `contract_type` values (returned by get_can_finance_status) to the key
// under which their financial settings appear in the same response payload.
// Keep `'1'` and `'8'` both pointing at `ten_financial_settings` so legacy
// Denefits contracts still resolve their min/max amount limits correctly.
export const CONTRACT_TYPE_SETTINGS_KEYS: Record<string, string> = {
  '1': 'ten_financial_settings',
  '2': 'no_fee_financial_settings',
  '3': 'new_ten_financial_settings',
  '4': 'ez_financial_settings',
  '6': 'di_financial_settings',
  '8': 'ten_financial_settings'
};

export const PATIENT_MOBILE_COUNTRY_CODE = '+1';

export const PROPOSAL_EXPIRY = '12 Months';

export const FINANCE_FLOW_STEP_LABELS: Record<number, string> = {
  1: 'Service Cost',
  4: 'Customer Details',
  5: 'Eligibility Check',
  6: 'Financing Offer',
  7: 'Payment Options',
  8: 'Customer Preview',
  9: 'Checkout',
  10: 'Customer Details',
  11: 'Customer Details'
};

export const INVALID_SSN_DEFAULTS = [
  '123456789', '002281852', '042103580', '062360749', '078051120', '095073645', '128036045',
  '135016629', '141186941', '165167999', '165187999', '165207999', '212099999', '165227999',
  '306302348', '165247999', '189092294', '308125070', '212097694', '549241889', '468288779'
];

export const MESSAGES = {
  INFO: {
    ALREADY_EXISTS: 'This service has already been added.'
  },
  ERROR: {
    MULTIPLE_SERVICES: (services: string[]) =>
      `Please remove duplicate service${services.length > 1 ? 's' : ''}: ${services.join(', ')}.`
  }
};
